import { ISidebarConfig, ISidebarSection } from '../components/sidebar-menu/sidebar-menu.interface';
import { BASE_SIDEBAR_SECTION } from './base.config';
import { GUARD_SIDEBAR_SECTION } from './guard.config';
import { HR_SIDEBAR_SECTION } from './hr.config';

export const SYSTEM_ADMIN_SIDEBAR_SECTION: ISidebarSection = {
    id: 'system-admin',
    title: 'Sistema',
    items: [
        {
            id: 'companies',
            title: 'Empresas',
            route: '/companies',
            icon: 'menu-dashboard',
        },
    ],
};

export const SYSTEM_ADMIN_SIDEBAR_CONFIG: ISidebarConfig = {
    role: 'SYSTEM_ADMIN',
    sections: [SYSTEM_ADMIN_SIDEBAR_SECTION, BASE_SIDEBAR_SECTION, HR_SIDEBAR_SECTION, GUARD_SIDEBAR_SECTION],
};
